import {
  Mapping,
  MappingField,
  ModelConceptAttributeWithHierarchyData,
} from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import {
  isMapping,
  isModelConceptClass,
} from 'src/containers/ProjectDiagram/utils/data';
import { getAllInheritedAttributes } from 'src/containers/ProjectDiagram/utils/getAllInheritedAttributes';
import { getClassHierarchy } from 'src/containers/ProjectDiagram/utils/getClassHierarchy';
import { getModelConceptClassValue } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';
import { getProjectAttributesByDomain } from 'src/utils/getProjectAttributesByDomain';

export const cleanupModelConceptHierarchyMappings = (model: Model) => {
  const classIris = model.nodeDataArray.reduce<Set<string>>((acc, nodeData) => {
    if (isModelConceptClass(nodeData)) {
      acc.add(nodeData.value);
    }
    return acc;
  }, new Set());
  const attributesByDomain = getProjectAttributesByDomain(
    model.modelData.attributesByIri
  );
  const hierarchyByIri = getClassHierarchy(model.linkDataArray, classIris);
  const inheritedAttributesByClass = Array.from(classIris).reduce<
    Record<string, Record<string, ModelConceptAttributeWithHierarchyData>>
  >(
    (agg, classIri) => ({
      ...agg,
      [classIri]: getAllInheritedAttributes({
        classIri,
        hierarchyByIri,
        attributesByDomain,
      }),
    }),
    {}
  );

  // For ALL mappings (because inheritance applies to descendant classes not directly linked to hierarchy changes)...
  model.linkDataArray.filter(isMapping).forEach((mapping) => {
    if (!mapping.to) {
      return;
    }
    const classIri = getModelConceptClassValue(mapping.to);

    // ... update or remove any fields that reference no-longer-inherited attributes
    let updatedAnyField = false;
    const newFields = Object.entries(mapping.fields).reduce(
      (agg, [fieldId, mappingField]) => {
        const newMappingField: MappingField = {
          ...mappingField,
          targets: mappingField.targets.filter(
            (attributeIri) =>
              inheritedAttributesByClass[classIri]?.[attributeIri]
          ),
        };
        updatedAnyField =
          updatedAnyField ||
          newMappingField.targets.length !== mappingField.targets.length;
        return {
          ...agg,
          [fieldId]: newMappingField,
        };
      },
      {}
    );

    if (updatedAnyField) {
      setDataProperty<Mapping>(model)(mapping, 'fields', newFields);
    }
  });
};
